// @flow
import React from 'react'
import { Switch } from 'react-router-dom'

import { PrivateRoute } from 'utils/routing'

import AccountsHome from 'containers/AccountsHome'

const AccountsLayout = () => (
  <Switch>
    <PrivateRoute exact path="/" component={AccountsHome} />
    <PrivateRoute
      path="/segments/:segmentId"
      requiredGate="ACCOUNTS_SEGMENTATION"
      component={AccountsHome}
    />
  </Switch>
)

export default AccountsLayout